export default function bankAccount(value) {
    return value.replace(/.{1,2}(?=(.{4})+$)/g, '$& ')
}
